import React from "react";
import { Layout, Sidebar } from "./components";
import styles from "./index.module.scss";

const DetailsV2 = () => {
  return (
    <div className={styles.root}>
     
        <Layout />
        <Sidebar />
    </div>
  );
};

export default DetailsV2;
